import { parseQuery } from '@calendly/http-tools'

const queryParams = parseQuery(window.location.search)
const isEmbeddedDomain = Boolean(queryParams.embed_domain)
const embedType = isEmbeddedDomain && queryParams.embed_type

const isEmbed = Boolean(embedType)

const target = window.parent !== window ? window.parent : null
const postMessageToParentWindow = (message) => target && target.postMessage(message, '*')

export default {
  track: (eventName, payload = {}) => (
    isEmbed && postMessageToParentWindow({ event: `calendly.${eventName}`, payload })
  )
}
